export const nodeConfigs = [
  {
    "chainId": 1,
    "name": "ETH",
    "symbol": "ETH",
    "explore": "https://etherscan.io/address/",
    "rpc": "https://mainnet.infura.io/v3/293245a17ce14c19b308ac776c2c2721",
    "support": ["base", "freeMint"],
  },
  {
    "chainId": 56,
    "symbol": "BNB",
    "name": "BSC Mainnet",
    "explore": "https://bscscan.com/address/",
    "rpc": "https://bsc-dataseed1.binance.org",
    "support": ["base", "freeMint", "dividend", "lpDividend", "lpWithInviter"],
    "swap": [
      {
        "label": "PanCake",
        "value": "0x10ED43C718714eb63d5aA57B78B54704E256024E"
      }
    ],
    "currency": [
      {
        "label": "USDT",
        "value": "0x55d398326f99059fF775485246999027B3197955"
      },
      {
        "label": "wBNB",
        "value": "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"
      },
      {
        "label": "BUSD",
        "value": "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56"
      },
      {
        "label": "其他代币",
        "value": "default"
      }
    ]
  },
  {
    "chainId": 97,
    "symbol": "TBNB",
    "name": "BSC Testnet",
    "explore": "https://testnet.bscscan.com/address/",
    "rpc": "https://data-seed-prebsc-2-s1.binance.org:8545",
    "support": ["base", "freeMint", "dividend", "lpDividend", "lpWithInviter"],
    "swap": [
      {
        "label": "PanCake",
        "value": "0xd99d1c33f9fc3444f8101754abc46c52416550d1"
      }
    ],
    "currency": [
      {
        "label": "BNB",
        "value": "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd"
      },
      {
        "label": "USDT",
        "value": "0x66E972502A34A625828C544a1914E8D8cc2A9dE5"
      },
      {
        "label": "CAKE",
        "value": "0xFa60D973F7642B748046464e165A65B7323b0DEE"
      },
      {
        "label": "其他代币",
        "value": "default"
      }
    ]
  },
  // {
  //   "chainId": 11155111,
  //   "symbol": "SepoliaETH",
  //   "name": "Sepolia Testnet",
  //   "explore": "https://sepolia.etherscan.io/address/",
  //   "rpc": "https://sepolia.infura.io/v3/293245a17ce14c19b308ac776c2c2721",
  //   "support": ["base", "freeMint"],
  // },
  {
    "chainId": 8453,
    "symbol": "ETH",
    "name": "BASE",
    "explore": "https://basescan.org/address/",
    "rpc": "https://base.blockpi.network/v1/rpc/public/",
    "support": ["base", "freeMint", "dividend"],
    "swap": [
      {
        "label": "UniswapV2",
        "value": "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D"
      }
    ],
    "currency": [
      {
        "label": "WETH",
        "value": "0xee01c0cd76354c383b8c7b4e65ea88d00b06f36f"
      },
      {
        "label": "USDC",
        "value": "0x8192dA45b932EFDc56dee24aC205d6Bcf209AA73"
      },
      {
        "label": "其他代币",
        "value": "default"
      }
    ]
  },
  {
    "chainId": 137,
    "symbol": "POL",
    "name": "Polygon",
    "explore": "https://polygonscan.com/address/",
    "rpc": "https://polygon-rpc.com",
    "support": ["base", "freeMint"],
  },
 
  {
    "chainId": 1116,
    "symbol": "CORE",
    "name": "Core",
    "explore": "https://scan.coredao.org/address/",
    "rpc": "https://rpc.coredao.org",
    "support": ["base", "freeMint", "dividend", "lpDividend", "lpWithInviter"],
    "swap": [
      {
        "label": "IceCreamswap",
        "value": "0xBb5e1777A331ED93E07cF043363e48d320eb96c4"
      },
      {
        "label": "LFGswap",
        "value": "0x42a0F91973536f85B06B310fa9C70215784F35a1"
      },
      {
        "label": "Archerswap",
        "value": "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D"
      }
    ],
    "currency": [
      {
        "label": "USDT",
        "value": "0xdAC17F958D2ee523a2206206994597C13D831ec7"
      },
      {
        "label": "USDC",
        "value": "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
      },
      {
        "label": "wETH",
        "value": "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2"
      },
      {
        "label": "其他代币",
        "value": "default"
      }
    ]
  },
  {
    "chainId": 181866,
    "name": "YLEM Mainnet",
    "symbol": "YLEM",
    "explore": "https://www.ylemscan.io/addr?addr=",
    "rpc": "https://mainnet.ylem.network",
    "support": ["base", "freeMint"],
  },
  // {
  //   "chainId": 181869,
  //   "name": "YLEM Testnet",
  //   "symbol": "TYLEM",
  //   "explore": "https://test.ylemscan.io/addr?addr=",
  //   "rpc": "https://testnet.ylem.network",
  //   "support": ["base", "freeMint"],
  // },
  {
    "chainId": 66,
    "symbol": "OKT",
    "name": "OKX",
    "explore": "https://www.okx.com/zh-hans/web3/explorer/xlayer/address/",
    "rpc": "https://exchainrpc.okex.org",
    "support": ["base", "freeMint", "dividend", "lpDividend", "lpWithInviter"],
    "swap": [
      {
        "label": "OKCSwap",
        "value": "0xc97b81B8a38b9146010Df85f1Ac714aFE1554343"
      }
    ],
    "currency": [
      {
        "label": "USDT",
        "value": "0x382bb369d343125bfb2117af9c149795c6c65c50"
      },
      {
        "label": "OKT",
        "value": "0x8f8526dbfd6e38e3d8307702ca8469bae6c56c15"
      },
      {
        "label": "其他代币",
        "value": "default"
      }
    ]

  },
  {
    "chainId": 81457,
    "symbol": "ETH",
    "name": "Blast",
    "explore": "https://blastexplorer.io/address/",
    "rpc": "https://rpc.blast.io",
    "support": ["base", "freeMint"],
  },
  {
    "chainId": 42161,
    "symbol": "ETH",
    "name": "Arbitrum One",
    "explore": "https://arbiscan.io/address/",
    "rpc": "https://rpc.ankr.com/arbitrum",
    "support": ["base", "freeMint", "dividend"],
    "swap": [
      {
        "label": "Sushiswap",
        "value": "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506"
      }
    ],
    "currency": [
      {
        "label": "ETH",
        "value": "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1"
      },
      {
        "label": "USDT",
        "value": "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9"
      },
      {
        "label": "其他代币",
        "value": "default"
      }
    ]
  }
]
export const modeConfigs = [
  {
    name: "标准代币",
    path: "stardand",
    mode: "base",
    icon: require('@/assets/images/icon_sT.png'),
    iconActive: require('@/assets/images/icon_sT_active.png'),
  },
  {
      name: "公平铸造代币",
      path: "freeMint",
      mode: "freeMint",
      icon: require('@/assets/images/icon_sT.png'),
      iconActive: require('@/assets/images/icon_sT_active.png'),
  },
  {
    name: "本币分红",
    path: "holdReflection",
    mode: "dividend",
    icon: require('@/assets/images/icon_dT.png'),
    iconActive: require('@/assets/images/icon_dT_active.png'),
  },
  // {
  //     name: "USDT分红",
  //     path: "USDTReflection",
  //     icon: require('@/assets/images/icon_lp.png'),
  //     iconActive: require('@/assets/images/icon_lp_active.png'),
  // },
  {
    name: "LP分红",
    path: "LPReflection",
    mode: "lpDividend",
    icon: require('@/assets/images/icon_lp.png'),
    iconActive: require('@/assets/images/icon_lp_active.png'),
  },
  //   {
  //     name: "营销回流",
  //     path: "mR",
  //   },
  //   {
  //     name: "NFT分红",
  //     path: "NFTD",
  //   },
  {
    name: "LP分红+推荐奖励",
    path: "LPWithInviter",
    mode: "lpWithInviter",
    icon: require('@/assets/images/icon_lp.png'),
    iconActive: require('@/assets/images/icon_lp_active.png'),
  },
  //   {
  //     name: "314协议",
  //     path: "314p",
  //   },
  //   {
  //     name: "持币复利+推荐奖励",
  //     path: "hCRR",
  //   },
  //   {
  //     name: "Mint+暴力分红",
  //     path: "MintD",
  //   },
  //   {
  //     name: "Mint+底池燃烧",
  //     path: "MintPB",
  //   },
  //   {
  //     name: "LP挖矿+推荐奖励",
  //     path: "LPMRR",
  //   },
  {
    name: "实时GAS",
    path: "gasPrice",
    icon: require('@/assets/images/icon_rTG.png'),
    iconActive: require('@/assets/images/icon_rTG_active.png'),
  },
  {
    name: "批量发送Token",
    path: "transferToken",
    icon: require('@/assets/images/icon_bCB.png'),
    iconActive: require('@/assets/images/icon_bCB_active.png'),
  },
  {
    name: "批量检查钱包余额",
    path: "walletBalance",
    icon: require('@/assets/images/icon_bCB.png'),
    iconActive: require('@/assets/images/icon_bCB_active.png'),
  },
  {
    name: "批量生成钱包",
    path: "createWallet",
    icon: require('@/assets/images/icon_bCB.png'),
    iconActive: require('@/assets/images/icon_bCB_active.png'),
  },
  {
    name: "合约管理",
    path: "contractManage",
    icon: require('@/assets/images/icon_cV1.png'),
    iconActive: require('@/assets/images/icon_cV1_active.png'),
  },
  {
    name: "水龙头",
    path: "faucet",
    icon: require('@/assets/images/icon_rTG.png'),
    iconActive: require('@/assets/images/icon_rTG_active.png'),
  },
  //   {
  //     name: "控制台V2",
  //     path: "cV2",
  //   },
  {
    name: "联系我们",
    path: "contactUs",
    icon: require('@/assets/images/icon_cU.png'),
    iconActive: require('@/assets/images/icon_cU_active.png'),
  }
]